import { FONTS } from 'common/constants';
import { css } from 'styled-components';

export const largeTitle = css`
  font: 30px ${FONTS.semiBold};
`;
